<!--
 * @Description: 
 * @Date: 2021-02-04 20:43:57
-->
<template>
  <van-popup class="e-t-p" v-model="show" :close-on-click-overlay="false">
    <div class="e-t-p__box">
      <div class="e-t-p__header">
        <p class="e-t-p__title">{{title}}</p>
        <img class="e-t-p__close" src="@/static/img/close2.png" alt @click="close" />
      </div>
      <div class="e-t-p__body" :style="bodyStyle">
        <slot></slot>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'ExternalTitlePopup',
  props: {
    bodyStyle: {
      type: String,
      default: 'background: #fff'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: true
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    close() {
      this.show = false;
      this.$emit('close');
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
.e-t-p {
  background: transparent;
  &__box {
  }
  &__header {
    position: relative;
    min-height: 0.4rem;
    margin-bottom: 0.28rem;
  }
  &__title {
    font-size: 0.43rem;
    color: #fff;
    text-align: center;
    letter-spacing: .08rem;
  }
  &__close {
    width: 0.35rem;
    height: 0.35rem;
    position: absolute;
    top: 0;
    right: 0;
  }
  &__body {
    // min-width: 4rem;
    // min-height: 2rem;
    border-radius: 0.16rem;
  }
}
</style>
